// src/lib/meta-pixel.js
//
// Meta (Facebook) Pixel. Ugyanaz a szabály, mint a gtag-nél és a Clarity-nél:
// KIZÁRÓLAG süti-elfogadás után töltődik be (a CookieBanner hívja), enélkül
// minden hívás no-op.

export const META_PIXEL_ID = "1333137274863324";

let loaded = false;

export function loadMetaPixel() {
  if (typeof window === "undefined") return;
  if (loaded || !META_PIXEL_ID) return;
  loaded = true;

  // A Meta hivatalos snippetje
  if (!window.fbq) {
    const fbq = function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments);
      } else {
        fbq.queue.push(arguments);
      }
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";

  const first = document.getElementsByTagName("script")[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }

  window.fbq("init", META_PIXEL_ID);
  // Szandekosan NINCS itt PageView: SPA-nal az oldalmegtekintest kulon
  // kezeljuk (AnalyticsTracker), kulonben az elso nezet duplan menne ki.
}

function ready() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

// Meta által ismert, szabványos esemény (Lead, Contact, PageView, ...)
export function metaStandardEvent(name, params) {
  if (!ready()) return;
  try {
    window.fbq("track", name, params);
  } catch (e) {
    // a Pixel hibája ne vigye el az oldalt
  }
}

// --- nevesitett esemenyek ------------------------------------------------
// Ezeken a fuggvenyeken keresztul megy MINDEN Meta-esemeny (a kozponti
// track() is ezeket hivja), hogy ne szorodjanak szet a komponensekben.

export function trackMetaPageView(params) {
  metaStandardEvent("PageView", params);
}

export function trackMetaPhoneClick(params) {
  metaStandardEvent("Contact", Object.assign({ contact_method: "phone" }, params));
}

// Sikeres lead - CSAK a backend visszajelzese utan hivjuk.
// A lead_type mondja meg, honnan jott: quote_form | callback_popup
export function trackMetaLead(leadType, params) {
  metaStandardEvent("Lead", Object.assign({}, params, { lead_type: leadType }));
}
